import Vue from 'vue'

const AjaxLoader = Vue.component('ajax-loader', {
 	props: ["display"],  
	template: '#ajax_loader'
})

export default AjaxLoader;